import { mutationOptions, queryOptions } from '@tanstack/react-query'
import { QueryError } from 'src/queries/network.utils'
import {
  ReceiptAgentRun,
  StartReceiptAgentRunParams,
} from 'src/queries/organizations/receiptAgent/receiptAgent.models'
import {
  getReceiptAgent,
  startReceiptAgentRun,
} from 'src/queries/organizations/receiptAgent/receiptAgent.network'

export const receiptAgentQueryKeys = {
  status: (organizationId: string | undefined) =>
    ['receipt-agent', 'status', organizationId] as const,
}

export const receiptAgentQueries = {
  status: (organizationId: string | undefined) =>
    queryOptions({
      queryKey: receiptAgentQueryKeys.status(organizationId),
      queryFn: () => getReceiptAgent(organizationId!),
      enabled: Boolean(organizationId),
      staleTime: 5 * 60 * 1000,
    }),
}

export const receiptAgentMutations = {
  startRun: () =>
    mutationOptions<ReceiptAgentRun, QueryError, StartReceiptAgentRunParams>({
      mutationFn: ({ organizationId, accountingPeriodId }) =>
        startReceiptAgentRun(organizationId, accountingPeriodId),
    }),
}
